import Script from 'next/script';

const ADSENSE_CLIENT_ID = 'ca-pub-2214184889025947';

/**
 * Google AdSense Auto Ads loader.
 *
 * Renders the AdSense script tag for pages that monetize via ads instead of
 * conversion CTAs. Auto Ads handles placement automatically — no per-slot
 * <ins> markup needed. See lib/data/consumer-pages.ts for which pages opt in.
 */
export default function AdSense() {
  return (
    <Script
      id="adsense-auto-ads"
      async
      strategy="afterInteractive"
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`}
      crossOrigin="anonymous"
    />
  );
}
